export const getRGQuestionnaireComponent =
    (component: keyof typeof import('./rg-questionnaire.chunk')) =>
    async () => {
        const chunk = await import(
            /* webpackChunkName: "responsible-gaming" */
            './rg-questionnaire.chunk'
        );
        return chunk[component];
    };
